import {
  ASSET_H,
  ASSET_W,
  DEFAULT_GEODE,
  GEODE_DISPLAY,
  GEODE_FRAME,
  GEODE_HIT_RADIUS_RATIO,
  VIEWPORT_H,
} from '../constants';
import type { GeodeModel, WeaponModel, WorldModels } from './types';

export function weaponModelForGeode(geode: GeodeModel, base?: WeaponModel): WeaponModel {
  const defaults = base ?? createDefaultWorldModels().weapon;
  return {
    ...defaults,
    gripY: geode.cy + 80,
  };
}

export function createDefaultWorldModels(): WorldModels {
  const cx = ASSET_W * 0.76;
  // ~70% of stage height (was 76%) — raises geode + dust landing together.
  const cy = ASSET_H * 0.7;
  const geode: GeodeModel = {
    type: DEFAULT_GEODE,
    cx,
    cy,
    displaySize: GEODE_DISPLAY,
    shadow: { x: cx + 24, y: cy + 280, width: 720 },
    hitRadius: GEODE_DISPLAY * GEODE_HIT_RADIUS_RATIO,
  };

  return {
    stage: {
      worldWidth: ASSET_W,
      worldHeight: VIEWPORT_H,
      cloudDriftPxPerSec: 24,
      cloudCount: 4,
      bgBleedY: 12,
    },
    geode,
    weapon: {
      gripX: ASSET_W - 200,
      gripY: cy + 80,
      displayHeight: 810,
      windDeg: 52,
      aimYOffset: -120,
    },
    boogas: {
      player: { x: -100, y: 500, scale: 2.9 },
      tiger: {
        x: 2096,
        y: 1275,
        scale: 0.6,
        hitRadius: GEODE_FRAME * 0.6 * 0.35,
        tapsToAngry: 3,
        angryDurationMs: 3500,
      },
    },
  };
}
